export default "__VITE_ASSET__Cn7ITqTM__"